window.WMStorefrontAPI = (() => {

    async function graphql({
        storeDomain,
        apiVersion,
        query,
        variables = {}
    }) {

        const endpoint = `https://${storeDomain}/api/${apiVersion}/graphql.json`;

        console.log("Store Domain:", storeDomain);
        console.log("API Version:", apiVersion);
        console.log("Endpoint:", endpoint);

        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query,
                variables
            })
        });

        const json = await response.json();

        console.log("Status:", response.status);
        console.log("Response:", json);

        if (!response.ok) {
            throw new Error(
                `Storefront API request failed (${response.status})`
            );
        }

        if (json.errors) {
            console.error("GraphQL Errors:", json.errors);
            throw new Error("GraphQL request failed.");
        }

        return json.data;
    }

    async function getProducts({
        storeDomain,
        apiVersion,
        collectionHandle,
        first = 4,
        after = null
    }) {

        const query = `
        query GetCollectionProducts(
            $handle: String!,
            $first: Int!,
            $after: String
        ) {
            collection(handle: $handle) {
                products(
                    first: $first,
                    after: $after
                ) {
                    edges {
                        cursor
                        node {
                            id
                            title
                            handle
                            publishedAt
                            featuredImage {
                                url
                                altText
                                width
                                height
                            }
                            variants(first: 20) {
                                edges {
                                    node {
                                        id
                                        price {
                                            amount
                                            currencyCode
                                        }
                                        compareAtPrice {
                                            amount
                                            currencyCode
                                        }
                                        availableForSale
                                    }
                                }
                            }
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        }
        `;

        return graphql({
            storeDomain,
            apiVersion,
            query,
            variables: {
                handle: collectionHandle,
                first,
                after
            }
        });
    }

    return {
        getProducts
    };

})();